function roundHours(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round(Math.max(0, n) * 10) / 10;
}

export function formatTeacherBusyHours(teacher) {
  const busy = roundHours(teacher?.busyHours);
  const available = roundHours(teacher?.availableHours);
  if (busy == null && available == null) return '';
  const busyLabel = busy == null ? 0 : busy;
  if (available != null && available > 0) {
    return `Busy ${busyLabel} of ${available} hours this week`;
  }
  if (busyLabel > 0) return `Busy ${busyLabel} hours this week`;
  return '';
}

export function formatTeacherBusyHoursChip(teacher) {
  const busy = roundHours(teacher?.busyHours);
  const available = roundHours(teacher?.availableHours);
  if (busy == null && (available == null || available <= 0)) return '';
  const busyLabel = busy == null ? 0 : busy;
  if (available != null && available > 0) return `${busyLabel}/${available} h busy`;
  if (busyLabel > 0) return `${busyLabel} h busy`;
  return '';
}

export function teacherBusyPercent(teacher) {
  const busy = Number(teacher?.busyHours);
  const available = Number(teacher?.availableHours);
  if (!Number.isFinite(busy) || !Number.isFinite(available) || available <= 0) return null;
  return Math.min(100, Math.round((busy / available) * 100));
}
